import React from "react";

/**
 * Carte KPI commune aux pages du module Commerce.
 *
 * Objectif : garantir le même HTML, les mêmes espacements et la même
 * hiérarchie visuelle sur Agenda, Affaires et les autres pages Commerce.
 *
 * Une carte peut devenir interactive via onClick. Le rendu reste alors
 * sémantiquement un bouton, sans wrapper interactif supplémentaire.
 */
export default function CommerceMetricCard({
  label,
  value,
  detail,
  icon: Icon,
  tone = "blue",
  testId,
  className = "",
  onClick,
  active = false,
  ariaPressed,
}) {
  const toneClasses = {
    blue: "bg-[var(--do-accent-soft)] text-[var(--do-accent)]",
    red: "bg-[var(--do-accent-soft)] text-[var(--do-accent)]",
    amber: "bg-[var(--do-accent-soft)] text-[var(--do-accent)]",
    green: "bg-[var(--do-accent-soft)] text-[var(--do-accent)]",
  };

  const isCssColor =
    typeof tone === "string"
    && (
      tone.startsWith("#")
      || tone.startsWith("rgb")
      || tone.startsWith("hsl")
      || tone.startsWith("var(")
    );

  const interactive = typeof onClick === "function";
  const Root = interactive ? "button" : "article";

  return (
    <Root
      type={interactive ? "button" : undefined}
      onClick={onClick}
      aria-pressed={
        interactive
          ? ariaPressed ?? active
          : undefined
      }
      className={`lirah-card p-4 ${
        interactive
          ? "w-full text-left transition-[border-color,box-shadow,transform] hover:-translate-y-px focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--do-accent)] focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--do-bg)]"
          : ""
      } ${
        active
          ? "border-[var(--do-border-strong)] shadow-[var(--do-shadow-glow)]"
          : ""
      } ${className}`.trim()}
      data-testid={testId}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <div className="text-xs font-heading font-semibold text-[var(--do-muted)]">
            {label}
          </div>

          <div className="mt-2 truncate font-heading text-2xl font-black text-[var(--do-ink)]">
            {value}
          </div>

          <div className="mt-1 max-w-3xl text-sm text-[var(--do-muted)]">
            {detail}
          </div>
        </div>

        <div
          className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-xl ${
            isCssColor
              ? ""
              : toneClasses[tone] || toneClasses.blue
          }`}
          style={
            isCssColor
              ? {
                  color: tone,
                  backgroundColor: `${tone}12`,
                }
              : undefined
          }
        >
          <Icon
            size={18}
            weight="bold"
          />
        </div>
      </div>
    </Root>
  );
}
